<!-- <ngx-loading [show]="loading"></ngx-loading> -->
<div class="spinner" *ngIf="loading">
  <img src="assets/images/loading_page.gif" alt="loading" width="50px">
</div>
<!-- LOGIN MODULE -->

<body class="login_background" *ngIf="!loading">
  <div class="flex-column-reverse flex-lg-row flex-md-row flex-sm-column-reverse row">
    <div class="col-md-4">
      <div class=" slider-div-css">
        <div class="carousel slide" id="main-carousel" data-ride="carousel">
          <ol class="carousel-indicators">
            <li data-target="#main-carousel" data-slide-to="0" class="active"></li>
            <li data-target="#main-carousel" data-slide-to="1"></li>
            <li data-target="#main-carousel" data-slide-to="2"></li>
            <li data-target="#main-carousel" data-slide-to="3"></li>
          </ol><!-- /.carousel-indicators -->

          <div class="carousel-inner">
            <div class="carousel-item active">
              <img loading="lazy"  class="d-block img-fluid" src="assets/images/slider-img-1.svg" alt="">
              <div class="carousel-caption d-md-block">
                <h3>Why try InsuredMine?</h3>
                <h5>See for yourself how we are helping insurance agencies manage and grow their business with multiple
                  sales, engagement, and analytics tools all-in-one.</h5>
              </div>
            </div>
            <div class="carousel-item">
              <img loading="lazy"  class="d-block img-fluid" src="assets/images/slider-img-2.svg" alt="">
              <div class="carousel-caption d-md-block">
                <h3>Email Automation</h3>
                <h5>Automate your follow ups, create custom email campaigns, build email templates, customize email
                  sequence that reach the right people at the right time.</h5>
              </div>
            </div>
            <div class="carousel-item">
              <img loading="lazy"  class="d-block img-fluid" src="assets/images/slider-img-3.svg" alt="">
              <div class="carousel-caption d-md-block">
                <h3>Policy Wallet App</h3>
                <h5>A simple app designed to help your clients keep their policies and insurance information organized
                  and accessible on their mobile device. This will not only save you resources but also time, effort and
                  money.</h5>
              </div>
            </div>
            <div class="carousel-item">
              <img loading="lazy"  src="assets/images/slider-img-4.svg" alt="" class="d-block img-fluid">
              <div class="carousel-caption d-md-block">
                <h3>Marketing & Analytics Place</h3>
                <h5>View and understand the story your data is telling.
                  Use that knowledge to grow your business, cross-sales & retention. Unlock the hidden potential in your
                  data.</h5>
              </div>
            </div>
          </div><!-- /.carousel-inner -->

          <!-- <a href="#main-carousel" class="carousel-control-prev" data-slide="prev">
              <span class="carousel-control-prev-icon"></span>
              <span class="sr-only" aria-hidden="true">Prev</span>
            </a>
            <a href="#main-carousel" class="carousel-control-next" data-slide="next">
              <span class="carousel-control-next-icon"></span>
              <span class="sr-only" aria-hidden="true">Next</span>
            </a> -->
        </div><!-- /.carousel -->
      </div>
    </div><!-- /.container -->
    <div class="col-md-8">
      <div class="sign-in-div-css">
        <div class="col-md-12 align-items-center d-flex justify-content-start" *ngIf="displayScreenType !== 'signin'">
          <a role="button" class="secondary-btn" (click)="changeScreen('signin')">
            < Back to Sign In</a>
        </div>
        <!--  sign in div -->
        <div class="col-lg-6 col-md-9 mx-auto pl-0 pr-0" *ngIf="displayScreenType === 'signin'">
          <div class="right-div-css">
            <h2 class="mb24">Sign In</h2>
            <!-- LOGIN FORM -->
            <form class="" (ngSubmit)="login()" #loginForm="ngForm">
              <!-- Insuredmine login screen -->
              <div >
                <div class="form-custom" *ngIf="!is_sunstarinsurance">
                  <div class="form-group">
                    <label>Email <span class="asterisk">*</span></label>
                    <input type="email" class="form-control redLeftBorder" placeholder="Email" [(ngModel)]="user.email" type="email"
                      name="email" required>
                  </div>
                  <div class="form-group position-relative">
                    <label>Password <span class="asterisk">*</span></label>
                    <i class="icon-eye_open" *ngIf="displaySigninPassword"
                      (click)="displaySigninPassword = !displaySigninPassword"></i>
                    <i class="icon-eye_hide" *ngIf="!displaySigninPassword"
                      (click)="displaySigninPassword = !displaySigninPassword"></i>
                    <input [type]="displaySigninPassword ? 'text': 'password' " class="form-control redLeftBorder"
                      placeholder="Password" [(ngModel)]="user.password" name="password" required>
                  </div>
                  <div class="align-items-center d-flex form-group justify-content-end">
                    <label><a role="button" (click)="changeScreen('forget_password')">Forgot your password?</a></label>
                  </div>
                </div>

                <ng-container *ngIf="!is_sunstarinsurance">
                  <button type="submit" id="customer-loginbtn" class="primary-btn" *ngIf="!signInLoader">Sign In</button>
                  <button type="button" id="customer-loginbtn" class="primary-btn" disabled
                    *ngIf="signInLoader">Processing...</button>
                </ng-container>
                
                <ng-container *ngIf="is_sso_enabled">
                  <button class="primary-btn" type="button" *ngIf="!loading"
                    style="margin-left:5px;background-color:#414658; color:#fff;min-width: 125px;font-size: 12px;display: inline-block;"
                    id="customer-azure-loginbtn" (click)="onLoginWith0365()">
                    Continue with SSO
                  </button>
                  <button class="primary-btn" type="button" *ngIf="loading"
                    style="margin-left:5px;background-color:#414658; color:#fff;min-width: 125px;font-size: 12px;display: inline-block;"
                    id="customer-azure-loginbtn">
                    Processing...
                  </button>
                </ng-container>                
              </div>
            </form>
          </div>
        </div>
        <!-- forget pass div -->
        <div class="col-lg-6 col-md-9 mx-auto pl-0 pr-0" *ngIf="displayScreenType === 'forget_password'">
          <div class="right-div-css">
            <h2 class="mb24">Forgot your password?</h2>
            <h6 class="mb24">Enter the email address you signed up with below. An email will be sent containing a link
              to reset your password.</h6>
            <p class="text-danger" *ngIf="errorMsg"> {{msg}} </p>
            <form #f="ngForm">
              <div class="form-custom">
                <div class="form-custom">
                  <div class="form-group">
                    <label>Email <span class="asterisk">*</span> </label>
                    <input type="email" class="form-control redLeftBorder" (ngModelChange)="validateEmail(user_forget_password.email)" [(ngModel)]="user_forget_password.email"
                      placeholder="Email Address" name="email" required (keyup)="onKey($event)">
                  </div>
                </div>
                <button type="submit" class="primary-btn mr-btn" *ngIf="!forgetPasswordLoader"
                  [disabled]="!user_forget_password.email || user_forget_password.email == '' || !forget_email_valid"
                  (click)="submitForgetPasswordForm()">Send</button>
                <button type="button" class="primary-btn mr-btn" *ngIf="forgetPasswordLoader"
                  disabled>Sending...</button>
                <!-- <a class="secondary-btn" role="button" (click)="changeScreen('signin')">Back to Sign In</a> -->
              </div>
            </form>
          </div>
        </div>
        <!-- mfa token div -->
        <div class="col-lg-6 col-md-9 mx-auto pl-0 pr-0" *ngIf="displayScreenType === 'mfa_token_screen'">
          <div class="right-div-css">
            <h2 class="mb24">MFA Token</h2>
            <h6 class="mb24">Enter MFA token from Google Authenticator App.</h6>
            <p class="text-danger" *ngIf="errorMsg"> {{msg}} </p>
            <form #f="ngForm" (ngSubmit)="submitMfaTokenForm()">
              <div class="form-custom">
                <div class="form-custom">
                  <div class="form-group">
                    <label>Token</label>
                    <input type="text" class="form-control" id="mfa-token-input" [(ngModel)]="mfa_payload.token" placeholder="6 digit token"
                      name="text" required>
                  </div>
                </div>
                <ng-container *ngIf="mfa_payload.loading" >
                  <button type="button" class="primary-btn mr-btn" *ngIf="mfa_payload.loading"
                    disabled>Sending...</button>
                </ng-container>
                <ng-container *ngIf="!mfa_payload.loading" >
                  <button type="submit" class="primary-btn mr-btn" *ngIf="!mfa_payload.loading"
                    [disabled]="!mfa_payload.token || mfa_payload.token == ''">Send</button>
                  <!-- <button type="button" (click)="reconfigMfa()" class="primary-btn mr-btn">Reconfigure</button> -->
                </ng-container>
              </div>
            </form>
          </div>
        </div>
        <!-- qr code div -->
        <div class="col-lg-6 col-md-9 mx-auto pl-0 pr-0" *ngIf="displayScreenType === 'qr_code_screen'">
          <div class="right-div-css">
            <h2 class="mb24">Scan QR Code</h2>
            <h6 class="mb24">After Scanning, you can go back to signin page and try to login again</h6>
              <div class="form-custom qr-code-div">
                <ngx-qrcode [elementType]="qr_payload.type" [value]="qr_payload.value" errorCorrectionLevel="L">
                </ngx-qrcode>
              </div>
          </div>
        </div>
        <!-- success div -->
        <div class="col-lg-6 col-md-9 mx-auto pl-0 pr-0 text-center"
          *ngIf="displayScreenType === 'forget_password_success'">
          <div class="right-div-css">
            <img loading="lazy"  src="assets/images/success-pass.svg" class="succ-img">
            <h2 class="mb16">Success</h2>
            <h6 class="mb24">Check your inbox. We’ve sent an email with the password reset instructions.</h6>

            <!-- <div class="form-group justify-content-center d-flex align-items-center">
              <a role="button" class="secondary-btn" (click)="changeScreen('signin')">Back to Sign In</a>
            </div> -->
          </div>
        </div>
        <!-- reset pass div -->
        <div class="col-lg-6 col-md-9 mx-auto pl-0 pr-0" *ngIf="false">
          <div class="right-div-css">
            <h2 class="mb24">Enter new password</h2>
            <form #f="ngForm">
              <div class="form-custom">
                <div class="form-custom">
                  <div class="form-group position-relative">
                    <label>Password</label>
                    <i class="icon-eye_open"></i>
                    <input type="password" class="form-control" placeholder="Create Password" type="password"
                      name="password" required>
                  </div>

                  <div class="form-group position-relative">
                    <label>Password again</label>
                    <i class="icon-eye_open"></i>
                    <input type="password" class="form-control" placeholder="Enter Password Again" type="password"
                      name="password" required>
                  </div>
                </div>

                <button type="submit" class="primary-btn">Save</button>
              </div>
            </form>
          </div>
        </div>
        <!-- pass reset successfully -->
        <!-- success div -->
        <div class="col-lg-6 col-md-9 mx-auto pl-0 pr-0 text-center" *ngIf="false">
          <div class="right-div-css">
            <img loading="lazy"  src="assets/images/success-pass.svg" class="succ-img">
            <h2 class="mb16">Success</h2>
            <h6 class="mb24">Your password has been reset successfully.</h6>
          </div>
        </div>
        <!-- OTP verify screen -->
        <div class="col-lg-6 col-md-9 mx-auto pl-0 pr-0" *ngIf="displayScreenType === 'OTPVerifyScreen'">
          <div class="right-div-css">
            <h2 class="mb24">OTP Verify</h2>
            <h6 class="mb24">An OTP has been sent to your {{ authType === 'email' ? 'email' : 'phone number' }} {{authValue}}. Please enter to verify and login.</h6>
            <!-- <p class="text-danger" *ngIf="errorMsg"> {{msg}} </p> -->
            <form >
              <div class="form-custom">
                <div class="form-custom">
                  <div class="form-group">
                    <!-- <label>OTP</label> -->
                    <input type="text" class="form-control" style="width: 80%;" id="verifyOTP" [(ngModel)]="verifyOTP" placeholder="Enter OTP to verify"
                      name="text" required>
                      <span *ngIf="timeLeft > 0" class="timer-text">
                        OTP is valid for: {{ getTimeLeft() }}
                      </span>
                      <span *ngIf="timeLeft === 0" class="notetext">OTP has expired. Please resend OTP.</span>
                  </div>
                </div>

                <ng-container>
                  <button type="submit" class="primary-btn mr-btn" [disabled]="!verifyOTP || verifyOTP == ''" (click)="verifySendOTP()">Verify</button>

                  <button type="submit" class="primary-btn mr-btn" [disabled]="!showResend"  (click)="resendOtp()">Resend</button>
                </ng-container>
              </div>
            </form>
            <!-- <ng-container *ngIf="otpsend" >
                  <button type="button" class="primary-btn mr-btn" 
                    disabled>Sending...</button>
                </ng-container>
                <ng-container *ngIf="!otpsend" >
                  <button type="submit" class="primary-btn mr-btn" [disabled]="!verifyOTP || verifyOTP == ''" (click)="verifySendOTP()">Verify</button>
                  <button type="submit" class="primary-btn mr-btn" (click)="verifySendOTP()"
                    [disabled]="otpsend">
                    <span *ngIf="!showResend">Send</span>
                  <span *ngIf="showResend">Resend</span>
                  </button>
                </ng-container> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="bookmark">
      <h4 (click)="bookmark()">Click here to<a>Bookmark</a></h4>
  </div> -->
</body>
<!-- Modal -->
<div class="modal fade" id="forget-password-modal2" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel">Enter your email</h4>
      </div>
      <div class="modal-body">

      </div>
      <div class="modal-footer">
      
        <button type="button" class="mr8btn-primary">Save changes</button>
        <button type="button" class="secondary-btn" data-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="forget-password-modal" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <!-- <div class="modal-header" style="background-color:#f68a1e;color:#fff">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h3 class="modal-title">
          <strong>Reset Password</strong>
        </h3>
      </div> -->
      <div class="modal-body">

        <div class="row" style="margin:0 auto;">
          <div class="col-md-10 offset-md-1">
            <div class="panel panel-default">
              <div class="panel-body">
                <div class="text-center">
                  <h3>
                    <img loading="lazy"  src="assets/img/svg/forgotpasswd.png" class="wd">
                  </h3>
                  <h2 class="text-center">Forgot Password?</h2>
                  <p class="mb-5"> You can reset your password here. </p>
                  <p class="text-success" *ngIf="successMsg"> {{msg}} </p>
                  <p class="text-danger" *ngIf="errorMsg"> {{msg}} </p>
                  <div class="panel-body ">

                    <form class="form" #f="ngForm">
                      <!-- <fieldset> -->
                      <!-- {{user_forget_password | json}} -->
                      <div class="form-group">
                        <div class="input-group">
                          <span class="input-group-addon"><i class="glyphicon glyphicon-envelope color-blue"></i></span>

                          <input name="emailInput" required [(ngModel)]="user_forget_password.email"
                            placeholder="email address" class="form-control" type="email">
                        </div>
                      </div>
                      <div class="form-group">
                        <!-- <input class="btn btn-lg btn-orange btn-block" value="Send My Password" type="submit"> -->
                        <button style="background:#ef442b; color:#fff;"
                          [disabled]="!user_forget_password.email || user_forget_password.email == ''"
                          class="btn btn-block" (click)="submitForgetPasswordForm()"> Submit </button>
                      </div>
                      <!-- </fieldset> -->
                    </form>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <!-- <div class="row">
            <div class="col-md-12">
              <input type="text" name="user-email" class="form-control" [(ngModel)]="user_forget_password.email" required placeholder="your email" >
            </div>
          </div> -->

      </div>
      <!-- <div class="modal-footer">
        <div class="row">
          <div class="col-md-12">
            <button [disabled]="!f.valid" class="btn btn-orange pull-right" (click)="submitForgetPasswordForm()" > Submit </button>
          </div>
        </div>

      </div> -->

    </div>

  </div>
</div>

<!-- <div class="login_logo" *ngIf="currentAgency$ | async as currentAgency"> -->
<!-- <img loading="lazy"  src="assets/img/insuredmine_logo.png" alt="insured_logo" border="0"> -->
<!-- <img loading="lazy"  [src]="currentAgency.login.logo" alt="insured_logo" border="0"> -->
<!-- </div> -->
<!-- SLIDER -->
<!-- <div class="content" *ngIf="currentAgency$ | async as currentAgency" >

        <div id="slideshow">
          <div class="one">
            <h2 style="margin:1em 0 0em !important">
              <img loading="lazy"  [src]="currentAgency.login.logo" alt="insured_logo" border="0" style="width: 190px;">
            </h2>
            <h2 class="margin_none">
              <img loading="lazy"  class="img_200" src="https://image.ibb.co/jACr3d/insured_login.png" alt="insured_login" border="0">
            </h2>

            <p class="txt_center loginbanner_font">The smart way to grow your agency.</p>
            <br>
            <p class="txt_center">
              <a target="_blank" href="https://itunes.apple.com/us/app/insuredmine/id1333207063?mt=8">
                <img loading="lazy"  class="link-img" src="https://image.ibb.co/e8F3md/image.png" alt="">
              </a>
              <a target="_blank" href="https://play.google.com/store/apps/details?id=com.insuredmineinc.insuredmine&hl=en">
                <img loading="lazy"  class="link-img" src="https://image.ibb.co/kpgR6d/image.png" alt="">
              </a>
            </p>
          </div>
        </div>
      </div> -->
